<div class="navbar-shell">
  <div class="container navbar-shell-inner ps-3 pe-3">
    <nav class="navbar navbar-expand-lg navbar-global navbar-light p-0">
      <a class="navbar-brand ms-0" routerLink="/">
        <img [src]="logoSrc()" alt="Логотип" />
      </a>

      <div class="navbar-header-end">
        @if (canCreateIdea()) {
          <a
            routerLink="/idea/edit-v2/0"
            [queryParams]="{ bf: selectedBf()?.Id }"
            class="navbar-suggest-link"
            aria-label="Предложить идею"
            (click)="closeAll()"
          >
            <ui-button variant="solid-accent" class="action-btn-primary">
              <i
                class="fas fa-lightbulb action-btn-primary__icon"
                aria-hidden="true"
              ></i>
              <span class="navbar-suggest-btn-text">Предложить</span>
            </ui-button>
          </a>
        }
        <a
          routerLink="/userprofile"
          class="navbar-user-avatar navbar-header-avatar"
          pTooltip="Профиль"
          tooltipPosition="left"
        >
          <ui-avatar
            size="s"
            [fullName]="user()?.Title"
            [imageUrl]="userPhotoUrl()"
          />
        </a>

        <button
          type="button"
          class="navbar-toggler d-lg-none"
          (click)="toggleMobileMenu()"
          aria-controls="navbarCollapse"
          [attr.aria-expanded]="mobileMenuOpen()"
          aria-label="Открыть меню"
        >
          <span
            class="fas"
            [class.fa-bars]="!mobileMenuOpen()"
            [class.fa-xmark]="mobileMenuOpen()"
          ></span>
        </button>
      </div>

      <div
        class="collapse navbar-collapse"
        id="navbarCollapse"
        [class.show]="mobileMenuOpen()"
      >
        <ul class="navbar-nav me-auto navbar-main-nav">
          @for (item of mainLinks(); track item.link) {
            <li class="nav-item">
              <a
                class="navigation-link text-center nav-main-link"
                [routerLink]="item.link"
                routerLinkActive="active"
              >
                <i [class]="item.icon"></i>
                {{ item.label }}
              </a>
            </li>
          }

          @if (isFullContext()) {
            <li
              class="nav-item dropdown"
              [class.show]="openedDropdown() === 'manager'"
            >
              <button
                type="button"
                id="navbarDropdownManager"
                class="navigation-link dropdown-toggle text-center nav-main-link"
                aria-haspopup="true"
                [attr.aria-expanded]="openedDropdown() === 'manager'"
                (click)="toggleDropdown('manager')"
              >
                <i class="fas fa-university"></i>
                Менеджмент
              </button>
              <ul
                class="dropdown-menu"
                aria-labelledby="navbarDropdownManager"
                [class.show]="openedDropdown() === 'manager'"
              >
                @for (item of managerLinks(); track item.link) {
                  <li class="dropdown-item">
                    <a
                      [routerLink]="item.link"
                      routerLinkActive="active"
                      class="navigation-link"
                      [pTooltip]="item.label"
                      tooltipPosition="right"
                      (click)="closeAll()"
                    >
                      <i [class]="item.icon"></i>
                      <span class="list-item-title"> {{ item.label }}</span>
                    </a>
                  </li>
                }
              </ul>
            </li>
          }

          @if (isAdmin()) {
            <li
              class="nav-item dropdown"
              [class.show]="openedDropdown() === 'admin'"
            >
              <button
                type="button"
                id="navbarDropdownAdmin"
                class="navigation-link dropdown-toggle text-center nav-main-link"
                aria-haspopup="true"
                aria-label="Администрирование"
                [attr.aria-expanded]="openedDropdown() === 'admin'"
                (click)="toggleDropdown('admin')"
              >
                <i class="fas fa-book"></i>
              </button>
              <ul
                class="dropdown-menu"
                aria-labelledby="navbarDropdownAdmin"
                [class.show]="openedDropdown() === 'admin'"
              >
                @for (item of adminLinks; track item.link) {
                  <li class="dropdown-item">
                    <a
                      [routerLink]="item.link"
                      routerLinkActive="active"
                      class="navigation-link"
                      [pTooltip]="item.label"
                      tooltipPosition="right"
                      (click)="closeAll()"
                    >
                      <i [class]="item.icon"></i>
                      <span class="list-item-title"> {{ item.label }}</span>
                    </a>
                  </li>
                }
              </ul>
            </li>
          }
        </ul>

        <ul class="navbar-nav justify-content-end pe-0 navbar-actions">
          @if (isFullContext() || canSwitchBf()) {
            <li
              class="nav-item navbar-context-item d-flex align-items-center ms-lg-1"
            >
              <div class="ctx-switcher" #ctxRoot>
                <button
                  type="button"
                  class="ctx-trigger"
                  [class.open]="ctxOpen()"
                  (click)="toggleCtx()"
                  title="Бизнес-функция и организационная единица"
                  aria-haspopup="true"
                  [attr.aria-expanded]="ctxOpen()"
                >
                  <span class="ctx-trigger-text">
                    @if (canSwitchBf()) {
                      <span class="ctx-trigger-title">
                        {{ selectedBf()?.Title || '(Не выбрано)' }}
                      </span>
                    }
                    @if (isFullContext()) {
                      <span class="ctx-trigger-sub">
                        <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
                        <span class="text-truncate">{{
                          orgUnit()?.Title || '(Не выбрано)'
                        }}</span>
                      </span>
                    }
                  </span>

                  @if (!ctxSeen()) {
                    <span class="ctx-dot" aria-hidden="true"></span>
                  }
                  <i
                    class="fas fa-chevron-down ctx-chevron"
                    aria-hidden="true"
                  ></i>
                </button>

                @if (ctxOpen()) {
                  <div class="ctx-menu">
                    @if (canSwitchBf()) {
                      <div class="ctx-label">Бизнес-функция</div>
                      <div class="ctx-card">
                        <span class="ctx-card-icon">
                          <i class="fas fa-university" aria-hidden="true"></i>
                        </span>
                        <span class="ctx-card-title">
                          {{ selectedBf()?.Title || '(Не выбрано)' }}
                        </span>
                        <a
                          routerLink="/sbf"
                          class="ctx-change"
                          (click)="closeCtx()"
                          >Сменить</a
                        >
                      </div>
                      <a
                        routerLink="/start"
                        class="ctx-hint"
                        (click)="closeCtx()"
                      >
                        <i class="fas fa-compass" aria-hidden="true"></i>
                        Не уверены? Помогите определиться
                      </a>
                    }

                    @if (canSwitchBf() && isFullContext()) {
                      <div class="ctx-divider"></div>
                    }

                    @if (isFullContext()) {
                      <div class="ctx-label">Организационная единица</div>
                      <div class="ctx-card">
                        <span class="ctx-card-icon">
                          <i
                            class="fas fa-map-marker-alt"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span class="ctx-card-title">
                          {{ orgUnit()?.Title || '(Не выбрано)' }}
                        </span>
                        <a
                          routerLink="/select-orgunit"
                          class="ctx-change"
                          (click)="closeCtx()"
                          >Сменить</a
                        >
                      </div>
                    }
                  </div>
                }
              </div>
            </li>
          }

          <li
            class="nav-item navbar-trailing-actions d-flex align-items-center ms-lg-1"
          >
            <div class="navbar-trailing-actions-inner">
              <a
                class="navigation-link navbar-trailing-action-link text-center p-0"
                pTooltip="Ответить нам"
                tooltipPosition="right"
                href="mailto:tc_alerts@x5.ru"
                (click)="closeAll()"
              >
                <ui-button size="s" variant="solid-white">
                  <i class="fas fa-paper-plane"></i>
                </ui-button>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>
